import { useLocationQueryState } from '../../Common/useLocationQueryState';

export const ItemDetailsTabKey = 'item-details';
export const ItemDetailsTabQueryParam = 'itemTab';

export function useItemDetailTabNavigation() {
	return useLocationQueryState(ItemDetailsTabQueryParam, ItemDetailsTabKey);
}
